import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { UniversalModalService } from "@modules/+new/shared/universal-modal/universal-modal.service";
import { ModalCloseReason } from "@modules/+new/shared/universal-modal/entities/modal-close-reason.enum";
import { ModalOptions } from "@modules/+new/shared/universal-modal/entities/modal-options.interface";
import { ModalNodeDefinition } from "@modules/+new/shared/universal-modal/entities/modal-node.class";

@Component({
	selector: "modal-header-default",
	template: `
		<div class="left font-semibold">
			@if (options.showPrevious && hasPrevious) {
				<a href="#" (click)="goBack($event)" [tabIndex]="0">{{ "back" | translate }}</a>
			}
			<!-- todo: we can implement here (based ViewChild) auto disabling default previous button when ng-content is provided-->
			<ng-content select="[header-left]"></ng-content>
		</div>
		<h4 id="modal-title" class="title">{{
			options.headerTitleKey ? (options.headerTitleKey | translate) : options.headerTitle
		}}</h4>
		<div class="right font-semibold">
			<ng-content select="[header-right]"></ng-content>
			@if (options.showCancel) {
				<a href="#" (click)="cancel($event)" [tabIndex]="0">{{
					options.cancelKey ? (options.cancelKey | translate) : ("abort" | translate)
				}}</a>
			}
		</div>
	`,
	styleUrls: ["../headers.component.scss"],
	standalone: false
})
export class DefaultHeaderComponent {
	private current: ModalNodeDefinition = this.modal.current$.getValue();
	public hasPrevious: boolean = this.current.hasPrev;
	public _options: ModalOptions = this.current.definition.options;
	@Output() public closeClicked: EventEmitter<void> = new EventEmitter<void>();
	@Input() public hasBorder: boolean = true;
	@Input() public set options(options: Partial<ModalOptions>) {
		this._options = { ...this.current.definition.options, ...options };
	}
	public get options(): Partial<ModalOptions> {
		return this._options;
	}
	public cancel = ($event: MouseEvent): void => {
		$event.preventDefault();
		this.closeClicked.emit();
		const reason = window !== window.parent ? ModalCloseReason.close : ModalCloseReason.cancel;
		this.modal.close(reason);
	};

	public goBack = ($event: MouseEvent): void => {
		$event.preventDefault();
		this.modal.rewind();
	};

	constructor(@Inject(UniversalModalService) private modal) {}
}
